import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';

const AdminLayout: React.FC = () => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false); // Type for state

  return (
    <div className="flex">
      {/* Pass the state and setter to Sidebar */}
      <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />

      {/* Main Content */}
      <div
        className={`transition-all duration-300 ${
          isCollapsed ? 'ml-20' : 'ml-64'
        } flex-1`}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;
